import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup } from '@angular/forms';
import { AppBaseDataService } from 'src/app/_services/app-base-data.service';
import { ProductsService } from 'src/app/_services/products.service';

@Component({
  selector: 'app-product-shipping-info',
  templateUrl: './product-shipping-info.component.html',
  styleUrls: ['./product-shipping-info.component.scss']
})
export class ProductShippingInfoComponent implements OnInit {
  editform: FormGroup
  weightUOM:any=''

  constructor(
    private _fb: FormBuilder,
    public _productService: ProductsService,
    public _abd: AppBaseDataService,
  ) { }

  ngOnInit(): void {
    // this.weightUOM=this._abd.WeightUOM[0]
    this.initForm()
  }

  initForm() {
    let obj = this._productService.activeItem

    const weight = this.normalizeShippingValue(this._productService.shippingWeight);
    const height = this.normalizeShippingValue(this._productService.shippingHeight);
    const width = this.normalizeShippingValue(this._productService.shippingWidth);
    const length = this.normalizeShippingValue(this._productService.shippingLength);

    this._productService.shippingWeight = weight;
    this._productService.shippingHeight = height;
    this._productService.shippingWidth = width;
    this._productService.shippingLength = length;

    this.editform = this._fb.group({
      weight: [{value: weight,disabled: this._productService.isViewOnly}],
      height: [{value: height,disabled: this._productService.isViewOnly}],
      width: [{value: width,disabled: this._productService.isViewOnly}],
      length: [{value: length,disabled: this._productService.isViewOnly}],
    })
  }

  saveFn() {}

  onInput(e, what:string) {
    if(what=='shippingWeight') this._productService.shippingWeight = e.value;
    if(what=='shippingHeight') this._productService.shippingHeight = e.value;
    if(what=='shippingWidth') this._productService.shippingWidth = e.value;
    if(what=='shippingLength') this._productService.shippingLength = e.value;
  }

  onBlurSetDefault(
    field: 'shippingWeight' | 'shippingHeight' | 'shippingWidth' | 'shippingLength',
    controlName: 'weight' | 'height' | 'width' | 'length'
  ) {
    const control = this.editform?.get(controlName);
    if (!control) return;
    const current = control.value;
    const normalized = this.formatToTwoDecimals(
      current === '' || current === null || current === undefined ? 0 : current
    );
    control.setValue(normalized);
    if (field === 'shippingWeight') this._productService.shippingWeight = normalized;
    if (field === 'shippingHeight') this._productService.shippingHeight = normalized;
    if (field === 'shippingWidth') this._productService.shippingWidth = normalized;
    if (field === 'shippingLength') this._productService.shippingLength = normalized;
  }

  private formatToTwoDecimals(value: string | number): number {
    const num = typeof value === 'number' ? value : parseFloat(value);
    if (isNaN(num)) return 0;
    return parseFloat(num.toFixed(2));
  }

  private normalizeShippingValue(value: unknown): number {
    if (value === '' || value === null || value === undefined) return 0;
    return this.formatToTwoDecimals(value as string | number);
  }

}
